import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function foundVoltageBus() {
    return (
        <div data-cy="history-foundVoltage">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.foundVoltageBus" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faBolt} style={{ color: 'green' }} size="lg" />
            </Whisper>
        </div>
    );
}
